// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import AccountsController from "./accounts_controller"
application.register("accounts", AccountsController)

import AdminDashboardController from "./admin_dashboard_controller"
application.register("admin-dashboard", AdminDashboardController)

import AdminMessageTabsController from "./admin_message_tabs_controller"
application.register("admin-message-tabs", AdminMessageTabsController)

import AdminRoomTabsController from "./admin_room_tabs_controller"
application.register("admin-room-tabs", AdminRoomTabsController)

import AnalyticsController from "./analytics_controller"
application.register("analytics", AnalyticsController)

import AttachmentsManagerController from "./attachments_manager_controller"
application.register("attachments-manager", AttachmentsManagerController)

import AuthOverlayController from "./auth_overlay_controller"
application.register("auth-overlay", AuthOverlayController)

import AutoscrollController from "./autoscroll_controller"
application.register("autoscroll", AutoscrollController)

import AvatarPreviewController from "./avatar_preview_controller"
application.register("avatar-preview", AvatarPreviewController)

import BusinessAutocompleteToggleController from "./business_autocomplete_toggle_controller"
application.register("business-autocomplete-toggle", BusinessAutocompleteToggleController)

import CartModalController from "./cart_modal_controller"
application.register("cart-modal", CartModalController)

import CategoryFilterController from "./category_filter_controller"
application.register("category-filter", CategoryFilterController)

import ChatSizingController from "./chat_sizing_controller"
application.register("chat-sizing", ChatSizingController)

import ChatWidgetController from "./chat_widget_controller"
application.register("chat-widget", ChatWidgetController)

import ChatWidgetTriggerController from "./chat_widget_trigger_controller"
application.register("chat-widget-trigger", ChatWidgetTriggerController)

import ChatboxController from "./chatbox_controller"
application.register("chatbox", ChatboxController)

import CheckoutController from "./checkout_controller"
application.register("checkout", CheckoutController)

import ClipboardController from "./clipboard_controller"
application.register("clipboard", ClipboardController)

import CookieConsentController from "./cookie_consent_controller"
application.register("cookie-consent", CookieConsentController)

import CountupController from "./countup_controller"
application.register("countup", CountupController)

import CutoffController from "./cutoff_controller"
application.register("cutoff", CutoffController)

import DeviseUserController from "./devise_user_controller"
application.register("devise-user", DeviseUserController)

import DropdownController from "./dropdown_controller"
application.register("dropdown", DropdownController)

import FaqController from "./faq_controller"
application.register("faq", FaqController)

import FeaturedCarouselController from "./featured_carousel_controller"
application.register("featured-carousel", FeaturedCarouselController)

import FieldMappingController from "./field_mapping_controller"
application.register("field-mapping", FieldMappingController)

import FileUploadController from "./file_upload_controller"
application.register("file-upload", FileUploadController)

import FiltersController from "./filters_controller"
application.register("filters", FiltersController)

import FlashController from "./flash_controller"
application.register("flash", FlashController)

import GalleryController from "./gallery_controller"
application.register("gallery", GalleryController)

import HomeBottomNoticeController from "./home_bottom_notice_controller"
application.register("home-bottom-notice", HomeBottomNoticeController)

import HeaderSearchController from "./header_search_controller"
application.register("header-search", HeaderSearchController)

import HeroBannerController from "./hero_banner_controller"
application.register("hero-banner", HeroBannerController)

import InstantSearchController from "./instant_search_controller"
application.register("instant-search", InstantSearchController)

import ImageLoaderController from "./image_loader_controller"
application.register("image-loader", ImageLoaderController)

import JustAskController from "./just_ask_controller"
application.register("just-ask", JustAskController)

import LoadMoreController from "./load_more_controller"
application.register("load-more", LoadMoreController)

import PartsPageController from "./parts_page_controller"
application.register("parts-page", PartsPageController)

import MapsAutocompleteController from "./maps_autocomplete_controller"
application.register("maps-autocomplete", MapsAutocompleteController)

import MenuController from "./menu_controller"
application.register("menu", MenuController)

import ModalController from "./modal_controller"
application.register("modal", ModalController)

import NavbarController from "./navbar_controller"
application.register("navbar", NavbarController)

import NotificationsController from "./notifications_controller"
application.register("notifications", NotificationsController)

import OrderShippingController from "./order_shipping_controller"
application.register("order-shipping", OrderShippingController)

import PartSettingsModalController from "./part_settings_modal_controller"
application.register("part-settings-modal", PartSettingsModalController)

import PartsFilterController from "./parts_filter_controller"
application.register("parts-filter", PartsFilterController)

import PwaController from "./pwa_controller"
application.register("pwa", PwaController)

import QuickviewController from "./quickview_controller"
application.register("quickview", QuickviewController)

import RecaptchaFormController from "./recaptcha_form_controller"
application.register("recaptcha-form", RecaptchaFormController)

import QuoteModalController from "./quote_modal_controller"
application.register("quote-modal", QuoteModalController)

import RoleConfirmController from "./role_confirm_controller"
application.register("role-confirm", RoleConfirmController)

import SelectAllController from "./select_all_controller"
application.register("select-all", SelectAllController)

import SignInModalController from "./sign_in_modal_controller"
application.register("sign-in-modal", SignInModalController)

import StorefrontController from "./storefront_controller"
application.register("storefront", StorefrontController)

import TabsController from "./tabs_controller"
application.register("tabs", TabsController)

import TooltipController from "./tooltip_controller"
application.register("tooltip", TooltipController)

import TurboController from "./turbo_controller"
application.register("turbo", TurboController)

import TurboFrameLoaderController from "./turbo_frame_loader_controller"
application.register("turbo-frame-loader", TurboFrameLoaderController)

import TopNoticeCountController from "./top_notice_count_controller"
application.register("top-notice-count", TopNoticeCountController)

import UserDashboardController from "./user_dashboard_controller"
application.register("user-dashboard", UserDashboardController)
